<template>
  <v-layout class="my-2 align-center" row wrap>
    <v-flex xs4>{{ splitByAllCapitalLetters(field.Field) }}</v-flex>
    <v-flex xs8>
      <v-chip label small icon="pageview">
        <v-icon class="mr-1" >insert_drive_file</v-icon>
        <router-link :to="{ name: 'dataset', params: {id: field.FieldValue }}">
          {{ field.FieldValue }}
        </router-link>
      </v-chip>
    </v-flex>
  </v-layout>
</template>

<script>
  import { splitByAllCapitalLetters } from '@/helpers/strings'
  export default {
    props: {
      field: Object,
    },
    methods: {
      splitByAllCapitalLetters,
    },
  }
</script>